"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.confirmRecovery = confirmRecovery;
exports.createASP = createASP;
exports.deleteAccount = deleteAccount;
exports.endpoints = void 0;
exports.getRecoveryMethods = getRecoveryMethods;
exports.getSession = getSession;
exports.getTicket = getTicket;
exports.invalidateInvitation = invalidateInvitation;
exports.isUsernameAvailable = isUsernameAvailable;
exports.listASP = listASP;
exports.login = login;
exports.logout = logout;
exports.passwordAuth = passwordAuth;
exports.refresh = refresh;
exports.removeASP = removeASP;
exports.resetPassword = resetPassword;
exports.sendRecoveryCode = sendRecoveryCode;
exports.sessionLogout = sessionLogout;
exports.signup = signup;
exports.updatePassword = updatePassword;
exports.verify = verify;
exports.verifyInvitation = verifyInvitation;
exports.verifyRecoveryCode = verifyRecoveryCode;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _qs = _interopRequireDefault(require("qs"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var endpoints = exports.endpoints = {
  login: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/login");
    }
  },
  update: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/password");
    }
  },
  resetPassword: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/reset");
    }
  },
  signup: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/signup");
    }
  },
  available: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/available");
    }
  },
  verify: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/recovery/verify");
    }
  },
  verifyInvitation: {
    method: 'GET',
    url: function url() {
      return "https://web-marketing.edison.tech/onmailUnlock";
    }
  },
  invalidateInvitation: {
    method: 'GET',
    url: function url() {
      return "https://web-marketing.edison.tech/onmailInvalidateCode";
    }
  },
  logout: {
    method: 'POST',
    url: function url(orderId) {
      return "/".concat(_constants.API_V1, "/u/").concat(orderId, "/logout");
    }
  },
  refresh: {
    method: 'GET',
    url: function url(orderId) {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/u/").concat(orderId, "/refresh");
    }
  },
  getTicket: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/domain/ticket");
    }
  },
  "delete": {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/soft_delete_account");
    }
  },
  getSession: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/super_session");
    }
  },
  sessionLogout: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/super_session/logout");
    }
  },
  passwordAuth: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/extra/auth");
    }
  },
  listASP: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/asp");
    }
  },
  createASP: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/asp");
    }
  },
  removeASP: {
    method: 'DELETE',
    url: function url(aspId) {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/asp/").concat(aspId);
    }
  },
  getRecoveryMethods: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/reset_password/query");
    }
  },
  sendRecoveryCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/reset_password/gen_code");
    }
  },
  verifyRecoveryCode: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/reset_password/verify_code");
    }
  },
  confirmRecovery: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/").concat(_constants.NOAUTH_PREFIX, "/reset_password/confirm");
    }
  }
};
/**
 * Authentication user's login password
 *
 * @public
 * @param {string} email - Email address to login
 * @param {string} password - Password to authenticate
 * @returns {Promise<LoginResponse>}
 */
function login(_x) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var email, password, superSessionId, mfaCode, headers, options, _endpoints$login, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          email = _ref.email, password = _ref.password, superSessionId = _ref.superSessionId, mfaCode = _ref.mfaCode;
          headers = {
            'x-Auth-User': email,
            'x-Auth-Password': password
          };
          if (mfaCode) {
            headers['x-Auth-MFACode'] = mfaCode;
          }
          options = (0, _functools.compose)((0, _requests.withHeaders)(headers), (0, _utils.withSuperSession)(superSessionId))(_utils.defaultOptionals);
          _endpoints$login = endpoints.login, method = _endpoints$login.method, url = _endpoints$login.url;
          _context.next = 7;
          return (0, _requests.request)(url(), method, options);
        case 7:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _login.apply(this, arguments);
}
/**
 * Update password for authenticated user
 *
 * @param {Auth} auth - User validated authentication
 * @param {string} oldPassword - Current password
 * @param {string} newPassword - New password
 * @param {?string} superSessionId - Uniq browser session ID
 * @returns {Promise<API>}
 */
function updatePassword(_x2) {
  return _updatePassword.apply(this, arguments);
}
function _updatePassword() {
  _updatePassword = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var auth, oldPassword, newPassword, superSessionId, options, _endpoints$update, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth, oldPassword = _ref2.oldPassword, newPassword = _ref2.newPassword, superSessionId = _ref2.superSessionId;
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _utils.withSuperSession)(superSessionId), (0, _requests.withHeaders)({
            'x-Auth-Password': oldPassword,
            'x-Auth-NewPassword': newPassword
          }))(_utils.defaultOptionals);
          _endpoints$update = endpoints.update, method = _endpoints$update.method, url = _endpoints$update.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _updatePassword.apply(this, arguments);
}
/**
 * Create user
 *
 * @public
 * @param {string} email - User email address
 * @param {string} password - Password
 * @param {string} captcha - Token required from Google recaptcha
 * @returns {Promise<SignupResponse>}
 */
function signup(_x3) {
  return _signup.apply(this, arguments);
}
/**
 * Checks if a given username is available.
 *
 * Throws 409 if user already exists.
 */
function _signup() {
  _signup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
    var email, password, captcha, castle, firstName, lastName, birthday, tnc, optIn, recoveryMethod, options, _endpoints$signup, method, url, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          email = _ref3.email, password = _ref3.password, captcha = _ref3.captcha, castle = _ref3.castle, firstName = _ref3.firstName, lastName = _ref3.lastName, birthday = _ref3.birthday, tnc = _ref3.tnc, optIn = _ref3.optIn, recoveryMethod = _ref3.recoveryMethod;
          options = (0, _functools.compose)((0, _utils.withSignUpHeaders)({
            castle: castle,
            captcha: captcha,
            password: password,
            username: email,
            recoveryMethod: recoveryMethod
          }), (0, _utils.withSignUpBody)(recoveryMethod, firstName, lastName, birthday, tnc, optIn))(_utils.defaultOptionals);
          _endpoints$signup = endpoints.signup, method = _endpoints$signup.method, url = _endpoints$signup.url;
          _context3.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _signup.apply(this, arguments);
}
function isUsernameAvailable(_x4) {
  return _isUsernameAvailable.apply(this, arguments);
}
/**
 * Verifies a user's recovery email address.
 *
 * @public
 * @param token {string} - token returned by the server
 */
function _isUsernameAvailable() {
  _isUsernameAvailable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref4) {
    var username, options, _endpoints$available, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          username = _ref4.username;
          options = (0, _functools.compose)((0, _requests.withParams)({
            username: username
          }))(_utils.defaultOptionals);
          _endpoints$available = endpoints.available, method = _endpoints$available.method, url = _endpoints$available.url;
          _context4.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _isUsernameAvailable.apply(this, arguments);
}
function verify(_x5) {
  return _verify.apply(this, arguments);
}
function _verify() {
  _verify = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref5) {
    var token, options, _endpoints$verify, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          token = _ref5.token;
          options = (0, _functools.compose)((0, _requests.withHeaders)({
            Authorization: "Bearer ".concat(token)
          }))(_utils.defaultOptionals);
          _endpoints$verify = endpoints.verify, method = _endpoints$verify.method, url = _endpoints$verify.url;
          _context5.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _verify.apply(this, arguments);
}
function verifyInvitation(_x6) {
  return _verifyInvitation.apply(this, arguments);
} // Invalidates the invitation code
function _verifyInvitation() {
  _verifyInvitation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref6) {
    var code, params, _endpoints$verifyInvi, method, url, res;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          code = _ref6.code;
          // Implemented with vanilla fetch
          params = {
            type: 'onmail',
            apiKey: 'bdH0VGExAEIhPq0z5vwdyVuHVzWx0hcR',
            code: code
          };
          _endpoints$verifyInvi = endpoints.verifyInvitation, method = _endpoints$verifyInvi.method, url = _endpoints$verifyInvi.url;
          _context6.next = 5;
          return (0, _requests.request)("".concat(url(), "?").concat(_qs["default"].stringify(params)), method, _utils.defaultOptionals);
        case 5:
          res = _context6.sent;
          return _context6.abrupt("return", res);
        case 7:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _verifyInvitation.apply(this, arguments);
}
function invalidateInvitation(_x7) {
  return _invalidateInvitation.apply(this, arguments);
}
function _invalidateInvitation() {
  _invalidateInvitation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref7) {
    var code, params, url, res;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          code = _ref7.code;
          // Implemented with vanilla fetch
          params = {
            type: 'onmail',
            apiKey: 'bdH0VGExAEIhPq0z5vwdyVuHVzWx0hcR',
            code: code
          };
          url = endpoints.invalidateInvitation.url;
          _context7.next = 5;
          return fetch("".concat(url(), "?").concat(_qs["default"].stringify(params)));
        case 5:
          res = _context7.sent;
          return _context7.abrupt("return", res.ok);
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _invalidateInvitation.apply(this, arguments);
}
function logout(_x8, _x9) {
  return _logout.apply(this, arguments);
}
/**
 * Executes a request for a new access token using the refresh token.
 *
 * @public
 * @param {string} csrf - CSRF token that should be obtained from the browser cookies
 * @returns {Promise<object>} - Object containing the new access token
 */
function _logout() {
  _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(orderId, _ref8) {
    var auth, superSessionId, _endpoints$logout, method, url, options, res;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref8.auth, superSessionId = _ref8.superSessionId;
          _endpoints$logout = endpoints.logout, method = _endpoints$logout.method, url = _endpoints$logout.url;
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _utils.withSuperSession)(superSessionId))(_utils.defaultOptionals); // Using fetch to bypass credentials settings
          _context8.next = 5;
          return fetch(url(orderId), {
            method: method,
            credentials: 'include',
            headers: _objectSpread({
              'Content-Type': 'application/json'
            }, options.headers)
          });
        case 5:
          res = _context8.sent;
          return _context8.abrupt("return", res);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _logout.apply(this, arguments);
}
function refresh(_x10, _x11) {
  return _refresh.apply(this, arguments);
}
function _refresh() {
  _refresh = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(csrfToken, orderId) {
    var _endpoints$refresh, method, url, res, token, user, analyticsId;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _endpoints$refresh = endpoints.refresh, method = _endpoints$refresh.method, url = _endpoints$refresh.url; // Using fetch to bypass credentials settings
          _context9.next = 3;
          return fetch(url(orderId), {
            method: method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'x-Csrf-Token': csrfToken
            }
          });
        case 3:
          res = _context9.sent;
          if (res.ok) {
            _context9.next = 6;
            break;
          }
          throw new _requests.RequestError('', '', res.status);
        case 6:
          // $FlowFixMe
          token = res.headers.get('x-Auth-Token'); // $FlowFixMe
          user = res.headers.get('x-Auth-User'); // $FlowFixMe
          analyticsId = res.headers.get('x-Analytics-Id');
          return _context9.abrupt("return", {
            token: token,
            user: user,
            analyticsId: analyticsId
          });
        case 10:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _refresh.apply(this, arguments);
}
function getTicket(_x12) {
  return _getTicket.apply(this, arguments);
}
function _getTicket() {
  _getTicket = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(_ref9) {
    var auth, sessionId, _endpoints$getTicket, method, url, options, res;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          auth = _ref9.auth, sessionId = _ref9.sessionId;
          _endpoints$getTicket = endpoints.getTicket, method = _endpoints$getTicket.method, url = _endpoints$getTicket.url;
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _utils.withSuperSession)(sessionId))(_utils.defaultOptionals);
          _context10.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context10.sent;
          return _context10.abrupt("return", res);
        case 7:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getTicket.apply(this, arguments);
}
function deleteAccount(_x13, _x14) {
  return _deleteAccount.apply(this, arguments);
}
function _deleteAccount() {
  _deleteAccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(email, _ref10) {
    var auth, options, _endpoints$delete, method, url, res;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          auth = _ref10.auth;
          options = (0, _utils.withExtraAuth)(auth)(_utils.defaultOptionals);
          _endpoints$delete = endpoints["delete"], method = _endpoints$delete.method, url = _endpoints$delete.url;
          _context11.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context11.sent;
          return _context11.abrupt("return", res);
        case 7:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _deleteAccount.apply(this, arguments);
}
function getSession(_x15) {
  return _getSession.apply(this, arguments);
}
function _getSession() {
  _getSession = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(sessionId) {
    var options, _endpoints$getSession, method, url, res;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          options = (0, _utils.withSuperSession)(sessionId)(_utils.defaultOptionals);
          _endpoints$getSession = endpoints.getSession, method = _endpoints$getSession.method, url = _endpoints$getSession.url;
          _context12.next = 4;
          return (0, _requests.request)(url(), method, options);
        case 4:
          res = _context12.sent;
          return _context12.abrupt("return", res);
        case 6:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _getSession.apply(this, arguments);
}
function sessionLogout(_x16, _x17) {
  return _sessionLogout.apply(this, arguments);
}
/**
 * Returns a temporary JWT token authed by password
 *
 * @param {string} password
 * @param {Auth} auth
 */
function _sessionLogout() {
  _sessionLogout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(sessionId, _ref11) {
    var auth, options, _endpoints$sessionLog, method, url, res;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          auth = _ref11.auth;
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _utils.withSuperSession)(sessionId))(_utils.defaultOptionals);
          _endpoints$sessionLog = endpoints.sessionLogout, method = _endpoints$sessionLog.method, url = _endpoints$sessionLog.url;
          _context13.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context13.sent;
          return _context13.abrupt("return", res);
        case 7:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _sessionLogout.apply(this, arguments);
}
function passwordAuth(_x18, _x19) {
  return _passwordAuth.apply(this, arguments);
}
function _passwordAuth() {
  _passwordAuth = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(password, _ref12) {
    var auth, options, _endpoints$passwordAu, method, url, res;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          auth = _ref12.auth;
          options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withHeaders)((0, _defineProperty2["default"])({}, _constants.AUTH_PASSWORD_HEADER, password)))(_utils.defaultOptionals);
          _endpoints$passwordAu = endpoints.passwordAuth, method = _endpoints$passwordAu.method, url = _endpoints$passwordAu.url;
          _context14.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context14.sent;
          return _context14.abrupt("return", {
            token: res.getHeader(_constants.EXTRA_TOKEN_HEADER)
          });
        case 7:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _passwordAuth.apply(this, arguments);
}
/**
 * Returns a list of ASPs with ID and name
 *
 * @public
 * @param {ExtraAuth} auth
 */
function listASP(_x20) {
  return _listASP.apply(this, arguments);
}
function _listASP() {
  _listASP = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(_ref13) {
    var auth, options, _endpoints$listASP, method, url, res;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          auth = _ref13.auth;
          options = (0, _utils.withExtraAuth)(auth)(_utils.defaultOptionals);
          _endpoints$listASP = endpoints.listASP, method = _endpoints$listASP.method, url = _endpoints$listASP.url;
          _context15.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context15.sent;
          return _context15.abrupt("return", res);
        case 7:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _listASP.apply(this, arguments);
}
/**
 * Creates a ASP by given name
 *
 * @public
 * @param {string} name
 * @param {ExtraAuth} auth
 * @returns {CreateASPResponse}
 */
function createASP(_x21, _x22) {
  return _createASP.apply(this, arguments);
}
/**
 * Deletes an existed ASP by given ID
 *
 * @public
 * @param {string} aspId
 * @param {ExtraAuth} auth
 */
function _createASP() {
  _createASP = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(name, _ref14) {
    var auth, options, _endpoints$createASP, method, url, res;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          auth = _ref14.auth;
          options = (0, _functools.compose)((0, _utils.withExtraAuth)(auth), (0, _requests.withBody)({
            name: name
          }))(_utils.defaultOptionals);
          _endpoints$createASP = endpoints.createASP, method = _endpoints$createASP.method, url = _endpoints$createASP.url;
          _context16.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context16.sent;
          return _context16.abrupt("return", res);
        case 7:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _createASP.apply(this, arguments);
}
function removeASP(_x23, _x24) {
  return _removeASP.apply(this, arguments);
}
function _removeASP() {
  _removeASP = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(aspId, _ref15) {
    var auth, options, _endpoints$removeASP, method, url, res;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          auth = _ref15.auth;
          options = (0, _utils.withExtraAuth)(auth)(_utils.defaultOptionals);
          _endpoints$removeASP = endpoints.removeASP, method = _endpoints$removeASP.method, url = _endpoints$removeASP.url;
          _context17.next = 5;
          return (0, _requests.request)(url(aspId), method, options);
        case 5:
          res = _context17.sent;
          return _context17.abrupt("return", res);
        case 7:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _removeASP.apply(this, arguments);
}
function getRecoveryMethods(_x25) {
  return _getRecoveryMethods.apply(this, arguments);
}
function _getRecoveryMethods() {
  _getRecoveryMethods = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(account) {
    var options, _endpoints$getRecover, method, url, res;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          options = (0, _requests.withBody)({
            account: account
          })(_utils.defaultOptionals);
          _endpoints$getRecover = endpoints.getRecoveryMethods, method = _endpoints$getRecover.method, url = _endpoints$getRecover.url;
          _context18.next = 4;
          return (0, _requests.request)(url(), method, options);
        case 4:
          res = _context18.sent;
          return _context18.abrupt("return", res);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _getRecoveryMethods.apply(this, arguments);
}
function sendRecoveryCode(_x26, _x27) {
  return _sendRecoveryCode.apply(this, arguments);
}
function _sendRecoveryCode() {
  _sendRecoveryCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(_ref16, _ref17) {
    var account, recoveryMethod, captcha, options, _endpoints$sendRecove, method, url, res;
    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          account = _ref16.account, recoveryMethod = _ref16.method;
          captcha = _ref17.captcha;
          options = (0, _functools.compose)((0, _requests.withBody)({
            account: account,
            method: recoveryMethod
          }), (0, _utils.withCaptcha)(captcha))(_utils.defaultOptionals);
          _endpoints$sendRecove = endpoints.sendRecoveryCode, method = _endpoints$sendRecove.method, url = _endpoints$sendRecove.url;
          _context19.next = 6;
          return (0, _requests.request)(url(), method, options);
        case 6:
          res = _context19.sent;
          return _context19.abrupt("return", res);
        case 8:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _sendRecoveryCode.apply(this, arguments);
}
function verifyRecoveryCode(_x28, _x29) {
  return _verifyRecoveryCode.apply(this, arguments);
}
function _verifyRecoveryCode() {
  _verifyRecoveryCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(_ref18, _ref19) {
    var account, code, resetPreToken, options, _endpoints$verifyReco, method, url, res;
    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          account = _ref18.account, code = _ref18.code;
          resetPreToken = _ref19.resetPreToken;
          options = (0, _functools.compose)((0, _requests.withBody)({
            account: account,
            code: code
          }), (0, _requests.withHeaders)({
            'X-Reset-Code-Pre-Token': resetPreToken
          }))(_utils.defaultOptionals);
          _endpoints$verifyReco = endpoints.verifyRecoveryCode, method = _endpoints$verifyReco.method, url = _endpoints$verifyReco.url;
          _context20.next = 6;
          return (0, _requests.request)(url(), method, options);
        case 6:
          res = _context20.sent;
          return _context20.abrupt("return", res);
        case 8:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _verifyRecoveryCode.apply(this, arguments);
}
function confirmRecovery(_x30, _x31) {
  return _confirmRecovery.apply(this, arguments);
}
function _confirmRecovery() {
  _confirmRecovery = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(_ref20, _ref21) {
    var account, password, resetToken, options, _endpoints$confirmRec, method, url, res;
    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          account = _ref20.account, password = _ref20.password;
          resetToken = _ref21.resetToken;
          options = (0, _functools.compose)((0, _requests.withBody)({
            account: account,
            password: password
          }), (0, _requests.withHeaders)({
            'X-Reset-Code-Token': resetToken
          }))(_utils.defaultOptionals);
          _endpoints$confirmRec = endpoints.confirmRecovery, method = _endpoints$confirmRec.method, url = _endpoints$confirmRec.url;
          _context21.next = 6;
          return (0, _requests.request)(url(), method, options);
        case 6:
          res = _context21.sent;
          return _context21.abrupt("return", res);
        case 8:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _confirmRecovery.apply(this, arguments);
}
function resetPassword(_x32) {
  return _resetPassword.apply(this, arguments);
}
function _resetPassword() {
  _resetPassword = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(_ref22) {
    var password, token, options, _endpoints$resetPassw, method, url, res;
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          password = _ref22.password, token = _ref22.token;
          options = (0, _functools.compose)((0, _requests.withHeaders)({
            'x-Auth-NewPassword': password,
            Authorization: "Bearer ".concat(token)
          }))(_utils.defaultOptionals);
          _endpoints$resetPassw = endpoints.resetPassword, method = _endpoints$resetPassw.method, url = _endpoints$resetPassw.url;
          _context22.next = 5;
          return (0, _requests.request)(url(), method, options);
        case 5:
          res = _context22.sent;
          return _context22.abrupt("return", res);
        case 7:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _resetPassword.apply(this, arguments);
}
//# sourceMappingURL=auth.js.map